import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const FILES_BASE = BACKEND_URL;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default client;
